import { t } from "i18next"

export const petOptions = () => [
  { label: t("Allowed"), value: "allowed" },
  { label: t("Not Allowed"), value: "not-allowed" },
]

export const propertyOwnershipOptions = () => [
  { label: t("Owned"), value: "owned" },
  { label: t("Rented"), value: "rented" },
]

export const occupancyOptions = () => [
  { label: t("Vacant"), value: "vacant" },
  { label: t("Occupied"), value: "occupied" },
]

export const constructionOptions = () => [
  { label: t("Completed"), value: "completed" },
  { label: t("Under Construction"), value: "under-construction" },
]

export const inventoryTypeOptions = () => [
  {
    label: t("Project"),
    value: "project",
  },
  {
    label: t("Secondary"),
    value: "lead",
  },
]

export const mouStatusOptions = () => [
  { label: t("Draft"), value: "draft" },
  { label: t("Signed"), value: "signed" },
  { label: t("Expired"), value: "expired" },
]

export const campaignStatusList = () => [
  { label: t("Active"), value: "on" },
  { label: t("Inactive"), value: "off" },
]

export const leadPreQualificationStatus = () => [
  { label: t("Auto"), value: "1" },
  { label: t("Manual"), value: "0" },
]

export const campaignApprovalStatus = () => [
  { label: t("Auto"), value: "auto_approved" },
  { label: t("Manual"), value: "manual" },
]

export const staffTypes = () => [
  { label: t("Aggregated"), value: "aggregated" },
  { label: t("Average"), value: "average" },
  { label: t("Individual"), value: "individual" },
]

export const socialConnectorsStatusList = () => [
  { label: t("Connected"), value: "connected" },
  { label: t("Not Connected"), value: "notConnected" },
]
export const reportTypes = () => [
  { label: "Leads", value: "sales", tooltip: "Show KPIs and working for leads" },
  { label: "Affiliate", value: "affiliate", tooltip: "Show KPIs and working for affiliate" },
]
export const documentTypes = () => [
  { label: t("Lead Acknowledgement"), value: "lead_acknowledgement" },
  { label: t("Low Performance Warning One"), value: "low_performance_warning_one" },
  { label: t("Low Performance Warning Two"), value: "low_performance_warning_two" },
  { label: t("Investigation"), value: "investigation" },
]

export const reservedModeOfPayments = ["cash", "bank_order", "online_payment"]

export const staffListing = () => [
  { label: "Sales", value: "sales,salesaff" },
  { label: "TSR", value: "telesales" },
]
